document.addEventListener("DOMContentLoaded", function () {

  const quizContent = document.getElementById("quizContent");
  const progressFill = document.getElementById("progressFill");
  const progressText = document.getElementById("progressText");

  const consentCheckbox = document.getElementById("quizConsent");
  const consentError = document.getElementById("quizConsentError");
  const buttonHelp = document.getElementById("quizButtonHelp");
  const startButton = document.getElementById("startQuizButton");

  const rulesModal = document.getElementById("quizRulesModal");
  const openRulesButton = document.getElementById("openQuizRules");
  const closeRulesButton = document.getElementById("closeQuizRules");
  const confirmRulesButton = document.getElementById("confirmQuizRules");

  if (!quizContent) return;

  let shopProducts = [];
  let currentQuestion = 0;
  let answers = [];
  let lastFocusedElement = null;

  // =================================
  // SHOPIFY PRODUKTŲ NUSKAITYMAS
  // =================================

  async function loadShopifyProducts() {
    try {
      const response = await fetch("/products.json?limit=250");

      if (!response.ok) {
        throw new Error("Nepavyko nuskaityti produktų.");
      }

      const data = await response.json();
      shopProducts = data.products || [];

      console.log("Shopify produktai:", shopProducts);
    } catch (error) {
      console.log("Produktų nuskaitymo klaida:", error);
    }
  }

  // =================================
  // KLAUSIMAI
  // =================================

  const questions = [
    {
      question: "Kokios dantų priežiūros priemonės jus domina?",
      options: [
        "✨ Dantų balinimo produktai",
        "❄️ Jautrių dantų priežiūra",
        "🪥 Kasdienė dantų priežiūra",
        "🦷 Balinimo kapos",
        "🤔 Nežinau – rekomenduokite man"
      ]
    },
    {
      question: "Koks yra pagrindinis jūsų tikslas?",
      options: [
        "Noriu baltesnės šypsenos",
        "Noriu sumažinti dantų jautrumą",
        "Noriu apsaugoti dantis kasdien",
        "Noriu pašalinti dantų dėmes ir spalvos pokyčius"
      ]
    },
    {
      question: "Ar jūsų dantys yra jautrūs?",
      options: [
        "Taip, labai jautrūs",
        "Kartais jaučiu jautrumą",
        "Ne, jautrumo nėra"
      ]
    },
    {
      question: "Kaip dažnai vartojate kavą, arbatą arba kitus dažančius produktus?",
      options: [
        "Kiekvieną dieną",
        "Kelis kartus per savaitę",
        "Retai"
      ]
    },
    {
      question: "Ko labiausiai tikitės iš produkto?",
      options: [
        "Švelnaus ir saugaus rezultato",
        "Pastebimo rezultato",
        "Maksimalaus efekto"
      ]
    },
    {
      question: "Kaip norėtumėte naudoti produktą?",
      options: [
        "Greitai ir paprastai",
        "Galiu skirti daugiau laiko",
        "Kasdienėje priežiūroje"
      ]
    },
    {
      question: "Ar anksčiau naudojote panašius produktus?",
      options: [
        "Ne, tai bus pirmas kartas",
        "Taip, naudojau balinimo produktus",
        "Taip, naudoju priežiūros produktus"
      ]
    },
    {
      question: "Kas jums svarbiausia?",
      options: [
        "Matomas rezultatas",
        "Saugumas ir komfortas",
        "Patogumas",
        "Kainos ir kokybės santykis"
      ]
    }
  ];

  // =================================
  // SUTIKIMO VARNELĖ
  // =================================

  function updateConsentState() {
    if (!consentCheckbox || !startButton) return;

    const isAccepted = consentCheckbox.checked;

    startButton.disabled = !isAccepted;
    startButton.setAttribute("aria-disabled", String(!isAccepted));

    if (buttonHelp) {
      buttonHelp.textContent = isAccepted
        ? "Sutikimas patvirtintas – galite pradėti testą."
        : "Norėdami pradėti testą, pažymėkite sutikimo laukelį.";

      buttonHelp.classList.toggle("accepted", isAccepted);
    }

    if (consentError) {
      consentError.textContent = "";
    }
  }

  if (consentCheckbox) {
    consentCheckbox.addEventListener("change", updateConsentState);
  }

  updateConsentState();

  // =================================
  // TAISYKLIŲ LANGAS
  // =================================

  function openRulesModal() {
    if (!rulesModal) return;

    lastFocusedElement = document.activeElement;

    rulesModal.classList.add("is-open");
    rulesModal.setAttribute("aria-hidden", "false");
    document.body.classList.add("quiz-modal-open");

    window.requestAnimationFrame(function () {
      closeRulesButton?.focus();
    });
  }

  function closeRulesModal() {
    if (!rulesModal) return;

    rulesModal.classList.remove("is-open");
    rulesModal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("quiz-modal-open");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  openRulesButton?.addEventListener("click", function (event) {
    event.preventDefault();
    openRulesModal();
  });

  closeRulesButton?.addEventListener("click", closeRulesModal);
  confirmRulesButton?.addEventListener("click", closeRulesModal);

  rulesModal?.addEventListener("click", function (event) {
    if (event.target.hasAttribute("data-close-rules")) {
      closeRulesModal();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (
      event.key === "Escape" &&
      rulesModal?.classList.contains("is-open")
    ) {
      closeRulesModal();
    }
  });

  // =================================
  // PRADĖTI TESTĄ
  // =================================

  startButton?.addEventListener("click", function () {
    if (!consentCheckbox?.checked) {
      if (consentError) {
        consentError.textContent =
          "Norėdami pradėti testą, turite susipažinti su taisyklėmis ir pažymėti sutikimo laukelį.";
      }

      consentCheckbox?.focus();
      return;
    }

    currentQuestion = 0;
    answers = [];

    showQuestion();
  });

  // =================================
  // PROGRESAS
  // =================================

  function updateProgress() {
    const percent =
      ((currentQuestion + 1) / questions.length) * 100;

    if (progressFill) {
      progressFill.style.width = percent + "%";
    }

    if (progressText) {
      progressText.textContent =
        `Klausimas ${currentQuestion + 1} iš ${questions.length}`;
    }
  }

  // =================================
  // KLAUSIMO RODYMAS
  // =================================

  function showQuestion() {
    const q = questions[currentQuestion];

    if (!q) {
      showResult();
      return;
    }

    quizContent.innerHTML = `
      <div class="quiz-card">

        <h2 class="quiz-question">
          ${q.question}
        </h2>

        <div class="quiz-options">
          ${q.options.map(function (option) {
            return `
              <button
                type="button"
                class="quiz-option"
              >
                ${option}
              </button>
            `;
          }).join("")}
        </div>

        <button
          class="quiz-button"
          id="nextButton"
          type="button"
          disabled
        >
          Toliau
        </button>

      </div>
    `;

    updateProgress();

    let selectedAnswer = "";

    const optionButtons =
      quizContent.querySelectorAll(".quiz-option");

    const nextButton =
      document.getElementById("nextButton");

    optionButtons.forEach(function (option) {
      option.addEventListener("click", function () {
        optionButtons.forEach(function (otherOption) {
          otherOption.classList.remove("active");
          otherOption.setAttribute("aria-pressed", "false");
        });

        option.classList.add("active");
        option.setAttribute("aria-pressed", "true");

        selectedAnswer = option.textContent.trim();

        if (nextButton) {
          nextButton.disabled = false;
        }
      });
    });

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        if (!selectedAnswer) return;

        answers.push(selectedAnswer);
        currentQuestion++;

        if (currentQuestion < questions.length) {
          showQuestion();
        } else {
          showResult();
        }
      });
    }
  }

  // =================================
  // PRODUKTO KATEGORIJA
  // =================================

  function getCategory(product) {
    const text = (
      (product.title || "") +
      " " +
      (product.body_html || "") +
      " " +
      (product.tags || "")
    ).toLowerCase();

    if (
      text.includes("sensitive") ||
      text.includes("sensitivity") ||
      text.includes("jautr") ||
      text.includes("relief") ||
      text.includes("repair")
    ) {
      return "sensitivity";
    }

    if (
      text.includes("pasta") ||
      text.includes("toothpaste")
    ) {
      return "paste";
    }

    if (
      text.includes("piešt") ||
      text.includes("pen") ||
      text.includes("pencil")
    ) {
      return "pen";
    }

    if (
      text.includes("kapa") ||
      text.includes("kap ")
    ) {
      return "kapa";
    }

    if (
      text.includes("gel") ||
      text.includes("whitening") ||
      text.includes("balin") ||
      text.includes("strip") ||
      text.includes("juost") ||
      text.includes("white")
    ) {
      return "whitening";
    }

    return "other";
  }

  // =================================
  // PRODUKTO PARINKIMAS
  // =================================

  function calculateRecommendation() {
    if (!shopProducts.length || answers.length < 5) {
      return null;
    }

    let bestProduct = null;
    let bestScore = -1000;

    const need = (answers[0] || "").toLowerCase();
    const sensitivity = (answers[2] || "").toLowerCase();
    const result = (answers[4] || "").toLowerCase();

    shopProducts.forEach(function (product) {
      let score = 0;
      const category = getCategory(product);
      const productTitle = (product.title || "").toLowerCase();

      // POREIKIS

      if (need.includes("balinimo")) {
        if (category === "whitening") {
          score += 50;
        }
      }

      if (
        need.includes("jautri") ||
        need.includes("jautrum")
      ) {
        if (category === "sensitivity") {
          score += 80;
        }
      }

      if (
        need.includes("priežiūra") ||
        need.includes("apsaug")
      ) {
        if (
          category === "paste" ||
          category === "sensitivity"
        ) {
          score += 60;
        }
      }

      if (need.includes("piešt")) {
        if (category === "pen") {
          score += 80;
        }
      }

      if (need.includes("kapos")) {
        if (category === "kapa") {
          score += 80;
        }
      }

      if (need.includes("profesional")) {
        if (
          productTitle.includes("professional") ||
          category === "whitening"
        ) {
          score += 70;
        }
      }

      // JAUTRUMAS

      if (sensitivity.includes("labai jautr")) {
        if (category === "sensitivity") {
          score += 40;
        }
      }

      if (sensitivity.includes("nėra")) {
        if (category === "sensitivity") {
          score -= 30;
        }
      }

      // REZULTATAS

      if (result.includes("maksimal")) {
        if (
          productTitle.includes("16") ||
          productTitle.includes("professional")
        ) {
          score += 25;
        }
      }

      if (score > bestScore) {
        bestScore = score;
        bestProduct = product;
      }
    });

    return bestProduct;
  }

  // =================================
  // AI REKOMENDACIJOS TEKSTAS
  // =================================

  function generateRecommendationText() {
    const need = (answers[0] || "").toLowerCase();
    const sensitivity = (answers[2] || "").toLowerCase();

    if (sensitivity.includes("labai jautr")) {
      return `
        Kadangi nurodėte padidėjusį dantų jautrumą,
        parinkome sprendimą, kuris orientuotas į komfortą
        ir jautresnių dantų priežiūrą.
      `;
    }

    if (need.includes("balinimo")) {
      return `
        Pagal jūsų pasirinkimus parinkome dantų balinimo sprendimą,
        kuris geriausiai atitinka jūsų norimą rezultatą ir naudojimo įpročius.
      `;
    }

    if (
      need.includes("pasta") ||
      need.includes("priežiūra")
    ) {
      return `
        Parinkome kasdienės priežiūros produktą,
        kuris padeda palaikyti prižiūrėtą šypseną.
      `;
    }

    if (need.includes("piešt")) {
      return `
        Parinkome patogų šypsenos priežiūros sprendimą,
        kurį lengva įtraukti į savo rutiną.
      `;
    }

    return `
      Pagal jūsų pateiktus atsakymus sistema atrinko
      labiausiai jūsų pasirinkimus atitinkantį produktą.
    `;
  }

  // =================================
  // REZULTATAS
  // =================================

  function showResult() {
    if (progressFill) {
      progressFill.style.width = "100%";
    }

    if (progressText) {
      progressText.textContent = "Analizė baigta";
    }

    quizContent.innerHTML = `
      <div class="quiz-card ai-loading">

        <h2>
          🦷 Analizuojame jūsų poreikius...
        </h2>

        <div class="loading-bar">
          <div class="loading-progress"></div>
        </div>

        <p>
          Renkame tinkamiausią produktą iš mūsų asortimento
        </p>

      </div>
    `;

    setTimeout(function () {
      const product = calculateRecommendation();

      if (!product) {
        quizContent.innerHTML = `
          <div class="quiz-card">

            <h2>
              Nepavyko rasti tinkamo produkto
            </h2>

            <p>
              Šiuo metu pagal jūsų atsakymus negalėjome pateikti
              tinkamos rekomendacijos. Pabandykite atlikti testą dar kartą.
            </p>

            <button
              class="quiz-button"
              id="restartQuizButton"
              type="button"
            >
              Atlikti testą dar kartą
            </button>

          </div>
        `;

        document
          .getElementById("restartQuizButton")
          ?.addEventListener("click", function () {
            currentQuestion = 0;
            answers = [];
            showQuestion();
          });

        return;
      }

      const productImage =
        product.images?.[0]?.src || "";

      quizContent.innerHTML = `
        <div class="quiz-card quiz-result-card">

          <h2>
            ✨ Jūsų rekomendacija
          </h2>

          ${
            productImage
              ? `
                <img
                  class="quiz-product-image"
                  src="${productImage}"
                  alt="${product.title || "Rekomenduojamas produktas"}"
                  loading="lazy"
                >
              `
              : ""
          }

          <h3>
            ${product.title}
          </h3>

          <p class="ai-recommendation">
            ${generateRecommendationText()}
          </p>

          <div class="quiz-result-warning">
            Rekomendacija yra informacinio pobūdžio. Prieš naudodami
            produktą perskaitykite gamintojo instrukciją ir įspėjimus.
          </div>

          <a
            class="quiz-button"
            href="/products/${product.handle}"
          >
            Peržiūrėti produktą
          </a>

        </div>
      `;
    }, 3500);
  }

  // =================================
  // PALEIDIMAS
  // =================================

  loadShopifyProducts();
});